export { default } from "./saga";



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/saga/index.js